import { jsx as _jsx } from "react/jsx-runtime";
import AdminPageLayout from '../../../layout/admin-page-layout';
import { DiscussionNew } from '../../_shared/discussions';
import { adminRoutes } from '../../../common/routes/admin';
function AdminDiscussionNew() {
    return (_jsx(AdminPageLayout, { children: _jsx(DiscussionNew, { routes: {
                listPath: adminRoutes.discussions.getURL(),
                newPath: adminRoutes.discussionsNew.getURL(),
                detailPath: (id) => adminRoutes.discussionsDetail.getURL({ id }),
            } }) }));
}
export default AdminDiscussionNew;
